/*
 * Copyright 2021 EPAM Systems, Inc. (https://www.epam.com/)
 * SPDX-License-Identifier: Apache-2.0
 */

export const DnDItemTypes = {
  SETTINGS: 'settings',
};
